wbApp.filter('contractTemplateType', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 0:
                return $translate.instant('TXT_LBL_CONTRACT_KINDERGARTEN');
            case 1:
                return $translate.instant('TXT_LBL_DOCTORS_ASSESSMENT');
            case 2:
                return $translate.instant('TXT_LBL_REGISTRATION_SHEET');
            case 3:
                return $translate.instant('TXT_LBL_LABOR_MARKET_POSITION');
            case 4:
                return $translate.instant('TXT_LBL_GDPR');
            case 5:
                return $translate.instant('TXT_FROM_TYPE_KINDERGARTEN_ENROLLMENT');
            case 6:
                return $translate.instant('TXT_FROM_TYPE_KINDERGARTEN_CUSTOM1');
            case 7:
                return $translate.instant('TXT_FROM_TYPE_KINDERGARTEN_CUSTOM2');
            case 8:
                return $translate.instant('TXT_ADMISSION_ACCEPTANCE');
            case 9:
                return $translate.instant('TXT_ADMISSION_REJECTION');
            default:
                return '';
        }
    };
}]);